import { useGlobalData } from "../../components/GlobalDataProvider";

import { logAndNotifyError } from "../logger";
import { IModuleRound, useRound } from "../roundHandler";
import { bfv_J3 } from "./BFV_J3";
import { bfv_J5 } from "./BFV_J5";
import { bfv_J9 } from "./BFV_J9";
import { IBFModule, IBFResult, IIndexÅtgärdad, IKontrollResultRow } from "../../types/BFL/Funktionskontroll";
import { BFLType } from "../../types/DBTables";
import { bfv_J10 } from "./BFV_J10";
import { bfv_J13 } from "./BFV_J13";
import { bfv_J11 } from "./BFV_J11";
import { bfv_J12 } from "./BFV_J12";
import { bfl_J3_FTX_FT } from "./BFL_J3_FTX_FT";
import { bfl_J3_FX_F } from "./BFL_J3_FX_F";
import { bfl_J3_S } from "./BFL_J3_S";
import { bfk_J1 } from "./BFK_J1";
import { bfl_J4_FTX } from "./BFL_J4_FTX";
import { bfl_J5_FTX_FT } from "./BFL_J5_FTX_FT";
import { bfv_J6 } from "./BFV_J6";
import { bfv_J8 } from "./BFV_J8";
import { bfv_J4 } from "./BFV_J4";

//BFL-Handler hanterar
export const useBflHandler = () => {
  const roundHandler = useRound();
  const globaldataHandler = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  // const bflSpecificPrepareData = (module: IModuleRound, bfName: BFLType, bfl: IBFResult, bflForm: IBFResult | undefined) => {
  //   const bfm = getBFModule(bfName);
  //   if (bfm?.bflSpecificPrepareData) bfm.bflSpecificPrepareData(module, bfl, bflForm);
  // };

  const detectDiffAndTransferÅtgärdad = (kontroller: IKontrollResultRow[], kontrollerForm: IKontrollResultRow[]) => {
    let diffDetected = false;
    if (kontrollerForm && kontroller) {
      for (var fi = 0; fi < kontrollerForm.length; fi++) {
        const msgIndex = kontrollerForm[fi].index;

        var row = kontroller.find((r) => r.index === msgIndex);
        if (row) {
          if (kontrollerForm[fi].energiSlag !== row.energiSlag) diffDetected = true;
          if (kontrollerForm[fi].index !== row.index) diffDetected = true;
          if (kontrollerForm[fi].kWhs !== row.kWhs) diffDetected = true;
          if (kontrollerForm[fi].message !== row.message) diffDetected = true;

          row.Åtgärdad = kontrollerForm[fi].Åtgärdad; //Transfer info from the form!
        } else {
          diffDetected = true;
        }
      }

      if (!diffDetected && kontrollerForm.length !== kontroller.length) {
        for (var i = 0; i < kontroller.length; i++) {
          const msgIndex = kontroller[i].index;

          var formRow = kontrollerForm.find((r) => r.index === msgIndex);
          if (!formRow) {
            kontrollerForm.push({ ...kontroller[i], ...{ Åtgärdad: false } });
          }
          diffDetected = true;
        }
      }
    }

    return diffDetected;
  };

  const transferÅtgärdad = <T extends IIndexÅtgärdad>(kontroller: T[], kontrollerForm: T[]) => {
    if (kontrollerForm && kontroller) {
      for (var fi = 0; fi < kontrollerForm.length; fi++) {
        const msgIndex = kontrollerForm[fi].index;

        var row = kontroller.find((r) => r.index === msgIndex);
        if (row) {
          row.Åtgärdad = kontrollerForm[fi].Åtgärdad; //Transfer info from the form!
          if (Array.isArray(row.Åtgärdad))
            //During a period we may have had a bug that made this an array. This is a fix for that.
            row.Åtgärdad = true;
        }
      }
    }

    return kontroller;
  };

  const setAllÅtgärdad = <T extends IIndexÅtgärdad>(kontroller: T[]) => {
    for (var i = 0; i < kontroller.length; i++) {
      var row = kontroller[i];

      row.Åtgärdad = true;
    }

    return kontroller;
  };

  const prepareData = (module: IModuleRound, bfName: BFLType, bflForm: IBFResult | undefined): IBFResult => {
    //let bflForm: IBFResult | undefined = undefined;
    const bfm = getBFModule(bfName);
    if (!globaldataHandler.data) return {} as IBFResult;

    const bfl = bfm.getResult(module, bimHandler, roundHandler, globaldataHandler.data, bflForm);
    if (bfl?.bfName === BFLType.Unknown) {
      logAndNotifyError("Must assign BFL name in getResult!");
    }
    if (bfl.error) {
      logAndNotifyError("BFL prepareData error : " + bfl.error);
    }

    if (bflForm) {
      const funktionskontroller = bfl.funktionsKontroller;
      //if (detectDiffAndTransferÅtgärdad(funktionskontroller, bflForm.funktionsKontroller)) bflForm.funktionsKontroller = funktionskontroller;

      const driftOptimeringar = bfl.driftOptimeringar;
      //if (detectDiffAndTransferÅtgärdad(driftOptimeringar, bflForm.driftOptimeringar)) bflForm.driftOptimeringar = driftOptimeringar;

      const funktionsKontrollerSEK = bfl.funktionsKontrollerSEK;

      bflForm.funktionsKontroller = transferÅtgärdad(funktionskontroller, bflForm.funktionsKontroller);
      bflForm.driftOptimeringar = setAllÅtgärdad(driftOptimeringar);

      bflForm.funktionsKontrollerSEK = transferÅtgärdad(funktionsKontrollerSEK ?? [], bflForm.funktionsKontrollerSEK ?? []);
      bfl.note = bflForm.note;
    }

    if (bfm?.bflSpecificPrepareData) bfm.bflSpecificPrepareData(module, bfl, bflForm);
    // bflSpecificPrepareData(module, bfName, bfl, bflForm);

    return bfl;
  };

  const getBFModule = (bfName: BFLType): IBFModule => {
    switch (bfName) {
      case BFLType.BFV_J3:
        return bfv_J3();
      case BFLType.BFV_J4:
        return bfv_J4();
      case BFLType.BFV_J5:
        return bfv_J5();
      case BFLType.BFV_J6:
        return bfv_J6();
      case BFLType.BFV_J8:
        return bfv_J8();
      case BFLType.BFV_J9:
        return bfv_J9();
      case BFLType.BFV_J10:
        return bfv_J10();
      case BFLType.BFV_J11:
        return bfv_J11();
      case BFLType.BFV_J12:
        return bfv_J12();
      case BFLType.BFV_J13:
        return bfv_J13();

      case BFLType.BFL_J3_FTX_FT:
        return bfl_J3_FTX_FT();
      case BFLType.BFL_J3_FX_F:
        return bfl_J3_FX_F();
      case BFLType.BFL_J3_S:
        return bfl_J3_S();

      case BFLType.BFK_J1:
        return bfk_J1();
      case BFLType.BFL_J4_FTX:
        return bfl_J4_FTX();
      case BFLType.BFL_J5_FTX_FT:
        return bfl_J5_FTX_FT();

      default:
        logAndNotifyError("bflHandler does not implement " + bfName);
        return null as any;
    }
  };

  //Public stuff
  var mod = {
    prepareData: prepareData, //Method called before useForm (In BFLFrom), that creates the hook. Update the data in the form to correspond to changes made in the config/round forms.
    //checkForNeededSetValues: checkForNeededSetValues, //Method called AFTER useForm(In BFLFrom). This is needed to detect when changes has been made due to new calculations in the bf, IF changes are detected
  };

  return mod;
};

const dflt = { useBflHandler };

export default dflt;
